import {z} from "zod";

export const applicationCreateDtoSchema = z.object({
    file: z.instanceof(File),
    organizationId: z.number(),
    lastName: z.string().min(1).max(255),
    firstName: z.string().min(1).max(255),
    patronymic: z.string().min(1).max(255).nullable(),
    iin: z.string(),
    date: z.date(),
    category: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5), z.literal(6), z.literal(8)]),
    time: z.string(),
});

export type ApplicationCreateDtoSchema = z.infer<typeof applicationCreateDtoSchema>